import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';

@customElement('chat-post-mention')
export class ChatPostMention extends LitElement {
  @property() postId = '';

  render() {
    return html`
      <div class="mt-2 bg-base-100 border border-base-300 rounded p-2">
        <p class="text-sm font-semibold truncate">Post Preview: ${this.postId}</p>
        <a href="/post/${this.postId}" class="btn btn-sm btn-link text-primary mt-1">View Channel →</a>
      </div>
    `;
  }
}
